import { BaseLoader } from "./BaseLoader";
import { LoaderEvent } from "../events/LoaderEvent";

export class JSONLoader extends BaseLoader {
    private _data: any = null;

    constructor(src: string, cacheTimestamp?: string, prependURL?: string, id?: string) {
        super(src, cacheTimestamp, prependURL, id);
    }

    getData(): any {
        return this._data;
    }

    protected getResponseType(): string {
        return "text";
    }

    protected onLoaded(event: any) {
        this._data = {
            jsonContent: JSON.parse(this._request.response),
            rawContent: this._request.response
        };

        this.dispatchEvent(new LoaderEvent(LoaderEvent.COMPLETE, this._data));
    }

    protected onError(event: any) {
        this.dispatchEvent(new LoaderEvent(LoaderEvent.ERROR));
    }
}
